function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMenuDown = function SvgMenuDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    },
    d: "M22.902 18.242a.507.507 0 0 1 .727.055.507.507 0 0 1-.055.726l-7.277 6.317a.517.517 0 0 1-.68-.004l-7.273-6.313a.515.515 0 1 1 .672-.78l6.941 6.023Zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    },
    d: "M22.902 15.129a.507.507 0 0 1 .727.055.507.507 0 0 1-.055.726l-7.277 6.317a.512.512 0 0 1-.68-.008L8.344 15.91a.515.515 0 1 1 .672-.781l6.941 6.023Zm0 0"
  }));
};

export default SvgMenuDown;